import React from 'react';
export const AddIcon = () => {
  return (
    <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <circle cx='12' cy='12' r='11' fill='var(--theme-primary, #810ea9)' />
      <rect x='11' y='8' width='2' height='8' rx='1' fill='#fff' />
      <path fill-rule='evenodd' clip-rule='evenodd' d='M15 11a1 1 0 1 1 0 2H9a1 1 0 1 1 0-2h6z' fill='#fff' />
    </svg>
  );
};
